<template>
    <!-- Company List -->
    <div class="col-sm-12">
        <div class="data-list-item add" @click.stop="$emit('add')">
            <div class="item-img-cont add-title">
                <i class="fa fa-plus" />
            </div>
            <div class="item-text-cont">
                <span class="item-title-add">{{ $t('common.add_new') }}</span>
                <font-awesome-icon icon="coins" class="card-body-icon" />
            </div>
        </div>
        <div class="col-12 nopads my-2 list-container">
            <Transition name="fade">
                <div v-if="resultList && resultList.length > 0" class="col-sm-12 list-content result-table">
                    <vue3-datatable
                        ref="resultTable"
                        :rows="resultList"
                        :columns="fields"
                        :pagination="false"
                        :sortable="true"
                    :sticky-header="true"
                    height="100%"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    @row-click="emitEdit"
                    />

                </div>
            </Transition>
        </div>
    </div>
</template>

<script>
import { workManagementHelper } from '../mixins/WorkManagementMixin';
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'CompanyList',
    components: { Vue3Datatable },
    mixins: [workManagementHelper],
    props: {
        results: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            fields: [
                { field: 'id', title: 'Id', sort: true, type: 'number', headerClass: 'routa-table-header'},
                { field: 'name', title: this.$t('companies.name'), sort: true, headerClass: 'routa-table-header',},
                { field: 'business_id', title: this.$t('companies.business_id'), sort: true, headerClass: 'routa-table-header'},
                { field: 'vat_id', title: this.$t('companies.vat_id'), sort: true, headerClass: 'routa-table-header'},
                { field: 'work_order', title: this.$t('companies.work_order'), sort: true, headerClass: 'routa-table-header'}
            ],
            resultList: [],
        };
    },
    watch: {
        results() {
            this.initTableItems()
        }
    },
    methods: {
        initTableItems() {
            let temp = []
            this.results.forEach(item => {
                let newItem = {
                    id: parseInt(item.id),
                    name: item.name,
                    business_id: item.business_id,
                    vat_id: item.vat_id,
                    work_order: item.work_order
                }
                temp.push(newItem)
            })
            this.$nextTick(() => {
                this.resultList = temp
            })
        },

        emitEdit(item) {
            const company = this.results.find(c => c.id === item.id)
            if (company) {
                this.$emit('edit', company)
            }
        }
    }
};
</script>

